import { apiRequest } from "../utils/config/apiRequest";
import { apiUrl } from "../utils/endPoints/apiUrl";


export const getComplaint = async (query =  {})=>{
    try{
        const response = await apiRequest({
            endUrl: apiUrl.complaints.listing,
            method : "GET",
            query
        })
        if(response.status === true){
            return{
                success : true,
                data : response.data,
            }
        }else{
            throw new Error(response.message || 'Failed');
        }

    }catch(error){
        console.error("Error in Creating User:", error);
        return { success: false, error: error.message };
    }
}